document.addEventListener('DOMContentLoaded', function () {
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsEl = document.querySelector('[data-predictive-search-results]');
  var form = document.querySelector('[data-predictive-search-form]');
  if (!input || !resultsEl || !form) return;

  var debounceTimer;
  var activeIndex = -1;
  var menuToggle = document.querySelector('.site-header__menu-toggle');

  function escapeHtml(value) {
    // Manual replace chain (not a textContent/innerHTML round-trip): the round-trip only
    // escapes &, <, > for text-node context. These escaped values are interpolated into
    // double-quoted HTML attributes (src="...", alt="...", href="..."), so quotes must be
    // escaped too or a value like `x" onmouseover="alert(1)` (or a normal product title like
    // `12" x 16" Framed Print`) breaks out of the attribute.
    return (value == null ? '' : String(value))
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function closeResults() {
    resultsEl.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    activeIndex = -1;
  }

  function openResults() {
    resultsEl.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    if (menuToggle) menuToggle.removeAttribute('open');
  }

  function render(terms, products) {
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');

    var safeTerms = escapeHtml(terms);

    if (products.length === 0) {
      var noResultsLabel = resultsEl.getAttribute('data-label-no-results').split('__TERMS__').join(safeTerms);
      resultsEl.innerHTML = '<p class="predictive-search__no-results">' + noResultsLabel + '</p>';
      openResults();
      return;
    }

    var html = products.map(function (product, index) {
      var safeTitle = escapeHtml(product.title);
      var safeImage = escapeHtml(product.featured_image);
      var safeUrl = escapeHtml(product.url);
      var image = product.featured_image
        ? '<div class="predictive-search__item-image"><img src="' + safeImage + '&width=80" alt="' + safeTitle + '"></div>'
        : '<div class="predictive-search__item-image"></div>';
      return (
        '<a href="' + safeUrl + '" class="predictive-search__item" role="option" id="predictive-search-option-' + index + '">' +
          image +
          '<div class="predictive-search__item-text">' +
            '<p class="predictive-search__item-title">' + safeTitle + '</p>' +
            '<p class="predictive-search__item-price">' + escapeHtml(window.BIP.formatMoney(product.price)) + '</p>' +
          '</div>' +
        '</a>'
      );
    }).join('');

    var viewAllLabel = resultsEl.getAttribute('data-label-view-all').split('__TERMS__').join(safeTerms);
    html += '<a href="' + form.action + '?q=' + encodeURIComponent(terms) + '" class="predictive-search__view-all">' + viewAllLabel + '</a>';

    resultsEl.innerHTML = html;
    openResults();
  }

  function fetchResults(terms) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(terms) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        // Guard against stale responses: if the input has changed since this request was
        // fired (a later keystroke's fetch may resolve first or this one may simply be slow),
        // discard this response rather than rendering results that no longer match what's typed.
        if (input.value.trim() !== terms) return;

        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(terms, products.map(function (p) {
          // /search/suggest.json returns price as a decimal-dollar string (e.g. "7.50"),
          // not integer cents, and featured_image as an object ({ url, alt, width, height, ... })
          // rather than a plain URL string. Convert/unwrap both before render() uses them.
          return {
            title: p.title,
            url: p.url,
            price: Math.round(parseFloat(p.price) * 100),
            featured_image: p.featured_image ? p.featured_image.url : null
          };
        }));
      })
      .catch(function () {
        closeResults();
      });
  }

  input.addEventListener('input', function () {
    var terms = input.value.trim();
    clearTimeout(debounceTimer);
    if (terms.length < 2) {
      closeResults();
      return;
    }
    debounceTimer = setTimeout(function () { fetchResults(terms); }, 200);
  });

  input.addEventListener('keydown', function (event) {
    var options = resultsEl.querySelectorAll('[role="option"]');
    if (resultsEl.hidden || options.length === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      activeIndex = Math.min(activeIndex + 1, options.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      activeIndex = Math.max(activeIndex - 1, 0);
    } else if (event.key === 'Enter' && activeIndex >= 0) {
      event.preventDefault();
      options[activeIndex].click();
      return;
    } else if (event.key === 'Escape') {
      closeResults();
      return;
    } else {
      return;
    }

    options.forEach(function (option, index) {
      option.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
    });
    input.setAttribute('aria-activedescendant', options[activeIndex].id);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.predictive-search')) {
      closeResults();
    }
  });

  var menuToggle = document.querySelector('.site-header__menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('toggle', function () {
      if (menuToggle.open) closeResults();
    });
  }
});
